import { Condition } from 'types';
import { baseQuery } from '../baseQuery';

type JobUpdateParams = {
  serviceId: number;
  sameDayService?: Condition;
  weekendService?: Condition;
  billtoId?: number;
};

export const putJob = async ({ serviceId, sameDayService, weekendService, billtoId }: JobUpdateParams) => {
  const { data } = await baseQuery('job', {
    type: 'PUT',
    body: {
      service_id: serviceId,
      sameday_service: sameDayService,
      weekend_service: weekendService,
      billto_id: billtoId,
    },
  });

  return data;
};
